export class AzureFileShareRestoreFileSpec {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileSpecType",
            "baseName": "fileSpecType",
            "type": "AzureFileShareRestoreFileSpecFileSpecTypeEnum",
            "format": ""
        },
        {
            "name": "targetFolderPath",
            "baseName": "targetFolderPath",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureFileShareRestoreFileSpec.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureFileShareRestoreFileSpecFileSpecTypeEnum;
(function (AzureFileShareRestoreFileSpecFileSpecTypeEnum) {
    AzureFileShareRestoreFileSpecFileSpecTypeEnum["File"] = "File";
    AzureFileShareRestoreFileSpecFileSpecTypeEnum["Folder"] = "Folder";
})(AzureFileShareRestoreFileSpecFileSpecTypeEnum || (AzureFileShareRestoreFileSpecFileSpecTypeEnum = {}));
